// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2k9li","footer":"ModalError_footer__1ErX7"};